// @flow

import React from 'react'

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps'

const apiKey = 'AIzaSyBB-v20WU4azMeQEzfQxAftw4EGkaCFbuY'

const center = { lat: 46.0475722, lng: 14.4588167 }

const zoom = 18

const options = {
  zoomControl: false,
  mapTypeControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
}

const mapProps = {
  defaultZoom: zoom,
  defaultCenter: center,
  defaultOptions: options,
}

export const mapUrl = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=3.exp&libraries=places`

const googleMap = withGoogleMap(() => (
  <GoogleMap {...mapProps}>
    <Marker position={center} />
  </GoogleMap>
))

export default withScriptjs(googleMap)



// WEBPACK FOOTER //
// ./src/components/Map/index.js